import React, { createContext, useState, useContext } from 'react';

// Create context with default value
const PageTitleContext = createContext({
  pageTitle: 'Dashboard',
  setPageTitle: () => {}
});

// Create provider component
export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState('Dashboard');

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
};

// Create custom hook for using this context
export const usePageTitle = () => useContext(PageTitleContext);

export default PageTitleContext; 